import { REPORT_CENTER_ITEMS, reportTitleKey } from "@/lib/reportCenterNav";

/** Map app routes to i18n keys under `nav.*` */
export const ROUTE_I18N_KEYS = {
  "/": "nav.dashboard",
  "/pos": "nav.pointOfSale",
  "/pos/invoice-history": "nav.invoiceHistory",
  "/pos/held-bills": "nav.heldBills",
  "/pos/sales-returns": "nav.salesReturns",
  "/pos/quotations": "nav.quotations",
  "/masters/categories": "nav.categories",
  "/masters/products": "nav.products",
  "/masters/barcode-labels": "nav.barcodeLabels",
  "/masters/privilege-cards": "nav.privilegeCards",
  "/masters/suppliers": "nav.suppliers",
  "/inventory": "nav.inventoryHub",
  "/inventory/stock": "nav.stockSummary",
  "/inventory/purchase-requests": "nav.purchaseRequests",
  "/inventory/purchase-orders": "nav.purchaseOrders",
  "/inventory/grn": "nav.grn",
  "/inventory/transfers": "nav.transfers",
  "/inventory/adjustments": "nav.adjustments",
  "/inventory/opening": "nav.openingPhysical",
  "/inventory/wastage": "nav.wastage",
  "/inventory/returns": "nav.supplierReturns",
  "/inventory/alerts": "nav.inventoryAlerts",
  "/accounts/schedules": "nav.schedules",
  "/accounts/accounts": "nav.accountsChart",
  "/accounts/receipt": "nav.receiptVoucher",
  "/accounts/payment": "nav.paymentVoucher",
  "/accounts/journal": "nav.journalVoucher",
  "/accounts/contra": "nav.contraVoucher",
  "/accounts/debit-note": "nav.debitNote",
  "/accounts/credit-note": "nav.creditNote",
  "/accounts/ledger": "nav.ledgerReport",
  "/accounts/trial-balance": "nav.trialBalance",
  "/accounts/profit-loss": "nav.profitLoss",
  "/accounts/balance-sheet": "nav.balanceSheet",
  "/accounts/cash-book": "nav.cashBook",
  "/accounts/bank-book": "nav.bankBook",
  "/accounts/day-book": "nav.dayBook",
  "/accounts/settings": "nav.accountingSettings",
  "/reports": "nav.reportCenter",
  "/admin/users": "nav.users",
  "/admin/roles": "nav.roles",
  "/admin/audit-log": "nav.auditLog",
  "/admin/counters": "nav.counters",
  "/admin/printers": "nav.printers",
  "/admin/company": "nav.companySetup",
  "/admin/store": "nav.storeSetup",
  "/admin/tax": "nav.taxSettings",
  "/admin/general": "nav.generalSettings",
  "/admin/whatsapp": "nav.whatsapp",
  "/admin/online-store": "nav.onlineStore",
  "/online/orders": "nav.onlineOrders",
  "/online/history": "nav.onlineHistory",
  "/reports/online-orders": "nav.onlineOrders",
};

/** Map report routes to i18n keys under `reports.*` */
export const REPORT_I18N_KEYS = Object.fromEntries(
  REPORT_CENTER_ITEMS.map((r) => [r.path, reportTitleKey(r.id)]),
);
